import { React } from "react";

import PageContainer from "../../components/PageContainer";
import PageHeaderContainer from "../../components/PageHeaderContainer";
import PageContentContainer from "../../components/PageContentContainer";

import { CgHome } from "react-icons/cg";
import { TelaInicialStyle } from "./style";
import { Code } from "../../components/Code/index";

import diretorioPrint from "../../assets/img/diretorio.png";
import importBootstrapCss from "../../assets/img/print_import_bootstrap_css.png";
import { ContainerWithSidebar } from "../../components/ContainerWithSidebar";

function TelaInicial({
  HandledarkMode,
  isDarkMode,
  decreaseFontSize,
  increaseFontSize,
  logOut,
}) {
  return (
    <ContainerWithSidebar
      increaseFontSize={increaseFontSize}
      decreaseFontSize={decreaseFontSize}
      HandledarkMode={HandledarkMode}
      isDarkMode={isDarkMode}
      logOut={logOut}
    >
      <PageContainer>
        <PageHeaderContainer title="Início" icon={<CgHome />} />
        <PageContentContainer>
          <TelaInicialStyle>
            <h1>Introdução</h1>
            <p style={{ textAlign: "justify" }}>
              Esta Documentação visa demonstrar e orientar na padronização dos
              layouts dos projetos T2M. A documentação contempla configuração
              inicial, esquema de cores, tamanhos pré-definidos dos elementos,
              fonte, ícones e componentes. O Layout está desenvolvido em sua
              grande maioria com a utilização de componentes bootstrap, em cada
              componente bootstrap utilizado, você encontrar o link do
              componente base utilizado, para alguns componentes que precisaram
              ser construídos ou sofreram grandes customizações do componente
              bootstrap original é possível obter o código fonte do componente e
              do estilo.
            </p>
            <p>A documentação está dividida da seguinte maneira:</p>
            <ul>
              <li>
                <p>
                  Na página inicio, contem as configurações iniciais e
                  instalação dos pacotes necessários para o correto
                  funcionamento dos componentes. Após a criação do projeto
                  React, você deverá seguir os passos apresentados nesta página
                  para realizar a instalação dos pacotes e configurações
                  iniciais.
                </p>
              </li>
              <li>
                <p>
                  Na página Tabela é apresentado o modelo de tabela e os
                  componentes necessários para apresentação de registros, como
                  input de buscas para aplicação de filtros, listagem na tabela
                  e o componente de controle de paginação.
                </p>
              </li>
              <li>
                <p>
                  Na página componentes estão listados diversos componentes que
                  poderão ser utilizados em diversos cenários, sendo sua
                  utilização conforme a necessidade de cada projeto.
                </p>
              </li>
              <li>
                <p>
                  Na página Paleta de Cores é possível conferir as cores e
                  códigos hexadecimal.
                </p>
              </li>
              <li>
                <p>
                  Na página de ícones está listado os ícones que poderão ser
                  utilizados sempre visando o ícone condizente com ação a ser
                  executada.
                </p>
              </li>
              <li>
                <p>
                  Na página de fomulário, um exemplo de layout e algumas
                  orientações na construção de formulários.
                </p>
              </li>
            </ul>
            <hr />
            <h2>Instalação dos pacotes</h2>
            <h3>React Bootstrap</h3>
            <p>
              Documentação:{" "}
              <a href="https://react-bootstrap.github.io/">React Bootstrap</a>
            </p>
            <p className="mb-4 code-container">
              <code>npm install react-bootstrap bootstrap</code>
            </p>
            <p>
              Após a instalação será necessário importar as folhas de estilos do
              bootstrap. No componente de maior nível da aplicação podendo ser o
              componente{" "}
              <em>
                <strong>App.js</strong>
              </em>{" "}
              ou{" "}
              <em>
                <strong>index.js</strong>
              </em>{" "}
              realizamos o import.
            </p>
            <p className="mb-4 code-container">
              <code>
                import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
              </code>
            </p>
            <p>Seu componente deverá se parecer com este</p>
            <img
              src={importBootstrapCss}
              alt="Print de tela demonstrando imports no componente App.js"
            />
            <hr />
            <h3>Styled Component</h3>
            <p>
              Documentação:{" "}
              <a href="https://styled-components.com/docs">Styled Component</a>
            </p>
            <p className="mb-4 code-container">
              <code>npm install --save styled-components</code>
            </p>
            <hr />
            <h3>React Icons</h3>
            <p>
              Documentação:{" "}
              <a href="https://react-icons.github.io/react-icons/">
                React Icons
              </a>
            </p>
            <p className="mb-4 code-container">
              <code>npm install react-icons --save</code>
            </p>
            <hr />
            <h3>Date Picker</h3>
            <p>
              Documentação{" "}
              <a href="https://www.npmjs.com/package/react-datepicker?activeTab=readme">
                react-datepicker
              </a>
            </p>
            <p className="mb-4 code-container">
              <code>npm install react-datepicker --save</code>
            </p>
            <hr />
            <h3>Toastify</h3>
            <p>
              NPM{" "}
              <a href="https://www.npmjs.com/package/react-toastify">
                react-toastify
              </a>
            </p>
            <p>
              Documentação{" "}
              <a href="https://fkhadra.github.io/react-toastify/introduction/">
                react-toastify
              </a>
            </p>
            <p className="mb-4 code-container">
              <code>npm install --save react-toastify</code>
            </p>
            <hr />
            <h2>Configurações Globais</h2>
            <p>
              Para o funcionamento correto de alguns componentes disponíveis
              neste Life Design, algumas configurações iniciais serão
              necessárias.
            </p>
            <h3>Importar Fontes</h3>
            <ul>
              <li>Source Sans 3 ExtraLight 200</li>
              <li>Source Sans 3 Regular 400</li>
            </ul>
            <p>
              Google Fonts:{" "}
              <a href="https://fonts.google.com/specimen/Source+Sans+3?query=Source+">
                Source Sans 3
              </a>
            </p>
            <h3>
              Criação do arquivo{" "}
              <em>
                <strong>colors.css</strong>
              </em>
              .
            </h3>
            <p>
              No diretorio{" "}
              <em>
                <strong>./src</strong>
              </em>{" "}
              crie um diretorio chamado{" "}
              <em>
                <strong>css</strong>
              </em>{" "}
              e dentro deste diretório vamos criar um arquivo de variáveis css
              com a paleta de cores. Os componentes utilizam esta paleta de
              cores para renderizar as cores corretamente.
              <strong>
                OBS: O Diretório css deve ficar no mesmo nível de pastas em que
                estarão os diretórios de components e pages. Em alguns templates
                de criação de projetos, podemos encontrar dentro <em>./src</em>{" "}
                ainda o diretório <em>app.</em> Verifique o nível do diretório
                corretamente.
              </strong>
            </p>
            <img
              src={diretorioPrint}
              alt="Print de tela demonstrando nível de diretório"
            />
            <p className="mt-4">
              No arquivo{" "}
              <em>
                <strong>colors.css</strong>
              </em>{" "}
              Inserir a paleta de cores abaixo.
            </p>
            <Code>
              {`:root{

    /* Paleta Cores T2M */
    --branco: #FFF;
    --branco-primario: #F3F5F6;
    --branco-secundario: #D9D9D9;
    --verde-primario:#01A998;
    --verde-secundario: #03A688;
    --cinza-primario: #585859;
    --cinza-secundario: #3D3D3D;
    --preto-primario: #0D0D0D;

    /* Cores Alertas */
    --vermelho-perigo: #fa5a54;
    --amarelo-atencao: #ffca2c;
    --azul-informativo: #5bc0de;
    --verde-sucesso: var(--verde-secundario);

    --cor-fonte: var(--cinza-secundario);
    --cor-fundo: var(--branco-primario);
  }`}
            </Code>
            <h3 className="mt-3">
              Configuração{" "}
              <em>
                <strong>Global.css</strong>
              </em>
            </h3>
            <p>
              Aqui vamos inserir algumas configurações padrões e o reset css.
            </p>
            <Code>
              {` 

/* Global style */
body{    
    background-color: var(--cor-fundo) !important;
    color: var(--cor-fonte) !important;
    font-family: 'Source Sans 3', sans-serif !important;    
}

/* Reset CSS */
*,
*:after,
*:before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-decoration: none;
}

body {
  font-size: 100%;
  list-style-type: none;  
}
`}
            </Code>
            <hr />
            <h3 className="mb-4">Responsividade</h3>
            <p>
              Este item não requer instalação, este recurso já está disponível
              pela instalação do Bootstrap realizada acima. Objetivo aqui é
              apenas compartilhar o link para documentação oficial sobre Grid
              Bootstrap. Todos os componentes e páginas deste documento estão
              estruturadas através do Grid Bootstrap.
            </p>
            <p>Estruturação das páginas com Grid System do Bootstrap.</p>
            <p>
              Documentação:{" "}
              <a href="https://react-bootstrap.netlify.app/docs/layout/grid">
                Grid System
              </a>
            </p>
          </TelaInicialStyle>
        </PageContentContainer>
      </PageContainer>
    </ContainerWithSidebar>
  );
}

export default TelaInicial;
